import React, { useContext, useEffect, useState } from "react";
import FormDataContext from "../../../Contexts/FormData.context";
import { formActionEnum, jsonKeyMapping } from "../../../Config/Constants";
import { TemplateObject } from "../../../Models/TemplateObject";
import InputWrapper from "./InputWrapper";

// Reuse parse / format logic from InputText (duplicated here to stay self-contained)
const NUMERIC_TOKEN = /^\s*[$€£]?\s*-?\d[\d,]*(?:\.\d+)?\s*[km]?\s*$/i;
function parseMoneyToNumber(raw: string): number | null {
  if (!raw) return null;
  let token = raw.trim().toLowerCase();
  token = token.replace(/^[$€£]\s*/, "").replace(/\s+/g, "");
  let mult = 1;
  if (/[km]$/i.test(token)) {
    const suf = token.slice(-1).toLowerCase();
    token = token.slice(0, -1);
    mult = suf === "k" ? 1_000 : 1_000_000;
  }
  token = token.replace(/,/g, "");
  const parts = token.split('.');
  if (parts.length > 2) token = parts.shift() + '.' + parts.join('');
  const n = parseFloat(token);
  return Number.isNaN(n) ? null : n * mult;
}
function formatUSD(n: number): string {
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

interface Props {
  formElement: TemplateObject;
  handleInputChange: (
    e: HTMLInputElement,
    startsWith: string,
    startsWithKey: string,
    inputFieldSeparator: string,
    prefillInputVal: string
  ) => void;
  onBlur: any; // match InputText signature
  fieldIndex: any;
  groups: any;
}

const InputCurrency = ({ formElement, handleInputChange, onBlur }: Props) => {
  const { state, dispatch } = useContext(FormDataContext);
  const { formData } = state;
  const [internal, setInternal] = useState<string>(
    (formData[formElement[jsonKeyMapping.FORM_ID]] as string) || ""
  );

  // Whenever formData changes externally (e.g., navigation), sync internal state
  useEffect(() => {
    const current = formData[formElement[jsonKeyMapping.FORM_ID]] as string;
    if (current !== undefined && current !== internal) {
      setInternal(current);
    }
  }, [formData, formElement, internal]);

  const applyFormat = (raw: string): string => {
    if (!raw) return "";
    if (!NUMERIC_TOKEN.test(raw)) return raw; // don't force if truly non-numeric text
    const num = parseMoneyToNumber(raw);
    if (num === null) return raw;
    return formatUSD(num);
  };

  const id = formElement[jsonKeyMapping.FORM_ID];
  const placeholder = formElement[jsonKeyMapping.FORM_PLACEHOLDER] || "";

  return (
    <InputWrapper
      formElement={formElement}
      label={formElement[jsonKeyMapping.FORM_LABEL] || ""}
      labelsub={formElement[jsonKeyMapping.FORM_LABEL_SUB] || ""}
      subtext={formElement[jsonKeyMapping.FORM_SUBTEXT] || ""}
    >
      <input
        id={id}
        className={`form-control ${formElement.inputClass ? formElement.inputClass : ""}`}
        placeholder={placeholder}
        type="text"
        value={internal}
        onChange={(e) => {
          const raw = e.target.value;
          setInternal(raw);
        }}
        onBlur={(e) => {
          const formatted = applyFormat(e.target.value);
          setInternal(formatted);
          dispatch({
            type: formActionEnum.SET_FORM_DATA,
            payload: { [id]: formatted },
          });
          // Delegate to parent (for addMore/group logic consistency)
            onBlur(e, formElement[jsonKeyMapping.FORM_LABEL] || "", formElement);
        }}
        maxLength={
          formElement.maxLength || formElement[jsonKeyMapping.FORM_MAX_LENGTH] || null
        }
      />
    </InputWrapper>
  );
};

export default InputCurrency;
